import { BmHttp } from "../utils/Global";

// CITAS-PROCEDIMIENTOS-03: reutiliza GET /cita_procedimiento?idcita= (ya
// existia, sin consumidor frontend real hasta ahora) para obtener los
// procedimientos ya vinculados a una cita al abrirla para editar.
export const ControllerListarProcedimientosDeCita = async (idcita) => {
    try {
        const response = await BmHttp().get(`/cita_procedimiento`, { params: { idcita } });
        if (response.data.success) {
            return {
                success: true,
                data: response.data.data,
            };
        } else {
            // La funcion real devuelve success:false cuando la cita simplemente
            // no tiene procedimientos -- no es un error, es un resultado valido.
            return {
                success: true,
                data: [],
            };
        }
    } catch (error) {
        console.error("Error al listar los procedimientos de la cita:", error);
        return {
            success: false,
            data: [],
            message: error.response?.data?.message || "Hubo un error al obtener los procedimientos de la cita",
        };
    }
};

export const ControllerVincularProcedimiento = async (nuevoProcedimiento) => {
    try {
        const response = await BmHttp().post("/cita_procedimiento", {
            idpaciente: nuevoProcedimiento.idpaciente,
            idExamenTipo: nuevoProcedimiento.idExamenTipo,
            precio: parseFloat(nuevoProcedimiento.precio),
            observaciones: nuevoProcedimiento.comentarios,
        });
    
        if (response.data.success) {
            return {
                success: true,
                message: "Procedimiento guardado correctamente",
            };
        } else {
            return {
                success: false,
                message: response.data.message || "Hubo un error al guardar el procedimiento",
            };
        }
    } catch (error) {
        console.error("Error al guardar el procedimiento:", error);
        return {
            success: false,
            message: error.response?.data?.message || "Hubo un error al guardar el procedimiento",
        };
    }
}

// CITAS-SEGURO-PLAN-PROCEDIMIENTOS-07: catalogo resuelto server-side segun el
// plan efectivo del paciente (asegurado) o su tarifario particular. Devuelve
// { success, data, sin_plan?, es_particular?, plan?, message }.
export const GetProcedimientosDisponiblesCita = async (idpaciente) => {
    try {
        const { data } = await BmHttp().get("/cita/procedimientos-disponibles", {
            params: { idpaciente },
        });
        return data;
    } catch (error) {
        return {
            success: false,
            data: [],
            message:
                error.response?.data?.message ||
                "Hubo un error al obtener los procedimientos disponibles",
        };
    }
};

/**
 * Tarifario de la clinica (procedimiento_company_precios).
 *
 * `idseguro` es OPCIONAL. Sin el, la llamada es EXACTAMENTE la de siempre --
 * el tarifario COMPLETO de todas las aseguradoras -- y los consumidores
 * existentes (ModalNuevoProcedimiento, el modal viejo del catalogo) no cambian
 * ni una linea.
 *
 * Con `idseguro` el servidor filtra, que es lo que este endpoint YA sabia
 * hacer y nadie le pedia (ver ControllerListarProcedimientos: lee
 * `request.query.idseguro`). Medido contra produccion: 9.592 filas y 6.847 KB
 * sin el parametro; 1.030 filas y 768 KB con `idseguro=8`. El resultado
 * visible es el mismo, porque el llamador filtraba por seguro en el navegador
 * DESPUES de bajarse el tarifario entero.
 */
export const ControllerProcedimientosPrecios = async (idseguro) => {
    try {
        const response = await BmHttp().get("/procedimiento_precios", {
            ...(idseguro ? { params: { idseguro } } : {}),
        });
        if (response.data.success) {
            return {
                success: true,
                data: response.data.data,
            }
        }else{
            return {
                success: false,
                message: response.data.message || "Hubo un error al obtener los precios de los procedimientos",
            }
        }
    } catch (error) {
        console.error("Error fetching procedimientos:", error);
        return {
            success: false,
            message: error.response?.data?.message || "Hubo un error al obtener los precios de los procedimientos",
        };
    }
}

export const ControllerObtenerProcedimientosPendientes = async (idpaciente, idseguro) => {
    try {
        const response = await BmHttp().post(`/cita_procedimiento_pendientes`,{
            idpaciente: idpaciente,
            idseguro: idseguro
        });
        if (response.data.success) {
            return {
                success: true,
                data: response.data.data,
            };
        } else {
            return {
                success: false,
                message: response.data.message || "Hubo un error al obtener los procedimientos",
            };
        }
    } catch (error) {
        console.error("Error al obtener los procedimientos:", error);
        return {
            success: false,
            message: error.response?.data?.message || "Hubo un error al obtener los procedimientos",
        };
    }
}

export const ControllerEliminarProcedimiento = async (idProcedimiento) => {
    try {
        const response = await BmHttp().post(`/procedimiento_precios`,{
            idProcedimiento: idProcedimiento,
        });
        if (response.data.success) {
            return {
                success: true,
                data: response.data.data,
            };
        } else {
            return {
                success: false,
                message: response.data.message || "Hubo un error al obtener los procedimientos",
            };
        }
    } catch (error) {
        console.error("Error al obtener los procedimientos:", error);
        return {
            success: false,
            message: error.response?.data?.message || "Hubo un error al obtener los procedimientos",
        };
    }
}

export const GetProcedimientoSeguro = async({ page = 1, limit = 10, filters }) => {
    try {
        
        const { fecha_inicial, fecha_final, estado, examen, paciente, seguro } = filters;
        const { data } = await BmHttp().get(`procedimiento_pendientes_seguros/`, {params: {page, limit, fecha_inicial, fecha_final, estado, examen, paciente, seguro }});
        return data;
        
    } catch (error) {
        return error.response.data;
    }
}

export const ListadoProcedimientos = async () => {
    try {
      const { data } = await BmHttp().get(`/procedimientos`);
      return data;
    } catch (error) {
      return error.response.data;
    }
  };

// COBERTURAS-09A -- prestaciones de asegurados pendientes de distribuir
// responsabilidad de seguro (worklist "Sin distribuir").
export const GetSinDistribuir = async ({ page = 1, limit = 20, filters = {} }) => {
    try {
        const { fecha_inicial, fecha_final, aseguradora, paciente, examen, especialidad } = filters;
        const { data } = await BmHttp().get(`coberturas/sin-distribuir/`, {
            params: { page, limit, fecha_inicial, fecha_final, aseguradora, paciente, examen, especialidad },
        });
        return data;
    } catch (error) {
        return error.response?.data || { success: false, data: [], message: "Error de red" };
    }
};

// COBERTURAS-09B -- generar la cobertura de seguro (100%) de una prestacion.
export const GenerarCoberturaSeguro = async ({ idprocedimiento_cita_paciente, id_plan }) => {
    try {
        const { data } = await BmHttp().post(`coberturas/generar`, {
            idprocedimiento_cita_paciente,
            id_plan,
        });
        return { ok: true, ...data };
    } catch (error) {
        const d = error.response?.data || {};
        return { ok: false, code: d.code || "ERROR", message: d.message || "No se pudo generar la cobertura.", extra: d.extra };
    }
};

// COBERTURAS-04 / 04C -- facturar N responsabilidades a UNA aseguradora.
//   modo: 'DETALLADA' (1 línea por responsabilidad) | 'RESUMIDA' (agrupa
//   servicio+precio iguales). Default backend: DETALLADA.
//   info_adicional: texto libre de cabecera (facturas.info_adicional_1), el
//   mismo campo que la factura normal. Vacío conserva el texto automático.
export const FacturarAseguradora = async ({ ids, vendedor_id = null, modo = "DETALLADA", info_adicional = null }) => {
    try {
        const { data } = await BmHttp().post(`coberturas/facturar`, { ids, vendedor_id, modo, info_adicional });
        return { ok: true, ...data };
    } catch (error) {
        const d = error.response?.data || {};
        return { ok: false, code: d.code || "ERROR", message: d.message || "No se pudo facturar a la aseguradora." };
    }
};

// COBERTURAS-04 -- cancelar una responsabilidad de seguro 'Por Cobrar'.
export const CancelarResponsabilidadSeguro = async ({ idprocedimiento_cita_paciente, motivo }) => {
    try {
        const { data } = await BmHttp().post(`coberturas/${idprocedimiento_cita_paciente}/cancelar`, { motivo });
        return { ok: true, ...data };
    } catch (error) {
        const d = error.response?.data || {};
        return { ok: false, code: d.code || "ERROR", message: d.message || "No se pudo cancelar la responsabilidad." };
    }
};